<template>
  <div id="vue-sidebar">
    <ul class="menu-out">
      <router-sidebar-link label="Contact Details" name="contact-details"/>
      <router-sidebar-link v-if="userHasPasswordSet" label="Change Password" name="change-password"/>
      <router-sidebar-link label="Accessibility Preferences" name="accessibility-preferences"/>
      <router-sidebar-link v-if="esignaturesEnabled" label="eSignatures" name="esignatures"/>
      <router-sidebar-link label="Document Preferences" name="user-document-preferences"/>
    </ul>
  </div>
</template>

<script lang="ts">
import type { JsonUserAccount } from "authentication/js/api/user-account.api";
import RouterSidebarLink from "authentication/components/mydetails/RouterSidebarLink.vue";
import { useUserAccountsStore } from "authentication/stores/user-accounts.store";
import { useConfigOptionStore } from "control-panel/control-panel.globals";
import { useSidebar } from "core/components/composable/sidebar";
import { useCurrentSessionStore } from "core/store/current-session.store";
import { defineComponent } from "vue";

export default defineComponent({
  components: { RouterSidebarLink },
  setup() {
    useSidebar();
    return {
      userAccountStore: useUserAccountsStore(),
      currentSessionStore: useCurrentSessionStore(),
      configOptionStore: useConfigOptionStore(),
    };
  },
  computed: {
    userId(): number | undefined {
      return this.currentSessionStore.getUserId;
    },
    user(): JsonUserAccount | undefined {
      if (this.userId === undefined) {
        return undefined;
      }
      return this.userAccountStore.getUser(this.userId);
    },
    esignaturesEnabled() {
      return this.configOptionStore.isConfigOptionEnabled("ESIGNATURES");
    },
    userHasPasswordSet() {
      return this.user?.passwordSet;
    },
  },
});
</script>
